module.exports = __webpack_public_path__ + "img/可爱.2abe31b8.gif";